export enum UpModulePathEnum {
  neuf = 'neuf',
  ancien = 'ancien',
  admin = 'admin',
  user = 'user',
  noAccess = 'no-access'
}
